var map = {
	"./american-flags-flagpoles-blue-sky.jpg": 78140,
	"./api_screenshot.png": 80398,
	"./chancellor_reeves_2024_autumn_budget.jpg": 86014,
	"./coding_screenshot.png": 24022,
	"./decile_chart_screenshot.png": 74506,
	"./github_screenshot.png": 19672,
	"./householdBaseline.png": 58605,
	"./household_screenshot.png": 96000,
	"./parameter_screenshot.png": 23667,
	"./policyEditor.png": 4779,
	"./policyImpact.png": 34154,
	"./policyScore.png": 12743,
	"./policy_screenshot.png": 51679,
	"./testing_screenshot.png": 81763,
	"./uk_docs.png": 74215,
	"./us_docs.png": 73110,
	"./westminster.jpg": 46787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22856;